export default __webpack_public_path__ + "static/media/bg.f63c565d.webp";